export const lenderDisplayNameMap = {
  cc_bank: 'Quill Bank',
  grasshopper_bank: 'Grasshopper Bank, N.A. d/b/a NetCredit',
  netcredit: 'NetCredit',
  republic_bank: 'Republic Bank & Trust Company',
  tab_bank: 'Transportation Alliance Bank, d/b/a TAB Bank',
} as const;
export type LenderDisplayNameT = typeof lenderDisplayNameMap[keyof typeof lenderDisplayNameMap];

export const productTypeArr = [
  'netcredit',
  'netcredit_line_of_credit',
  'netcredit_bank_partnership',
  'netcredit_bank_partnership_loc',
  'netcredit_bank_partnership_tab',
  'netcredit_bank_partnership_tab_loc',
  'netcredit_bank_partnership_ccb',
  'netcredit_bank_partnership_ccb_loc',
  'netcredit_bank_gh',
  'netcredit_bank_gh_loc',
] as const;

export type ProductTypeT = typeof productTypeArr[number];

export const productTypeDisplayArr = ['Line of Credit', 'Installment'] as const;

export type ProductTypeDisplayT = typeof productTypeDisplayArr[number];

export const locLoanTypes = [
  'netcredit_bank_partnership_loc',
  'netcredit_bank_partnership_ccb_loc',
  'netcredit_bank_partnership_tab_loc',
  'netcredit_line_of_credit',
  'netcredit_bank_gh_loc',
];

export type LocProductTypeT = typeof locLoanTypes[number];

export const installmentLoanTypes = [
  'netcredit_bank_partnership',
  'netcredit_bank_partnership_ccb',
  'netcredit_bank_partnership_tab',
  'netcredit',
  'netcredit_bank_gh',
];

export type InstallmentProductTypeT = typeof installmentLoanTypes[number];

export const OwnerTypeArr = [
  'cc_bank',
  'netcredit',
  'republic_bank',
  'tab_bank',
  'grasshopper_bank',
] as const;

export type OwnerT = keyof typeof lenderDisplayNameMap;

export type LoanStatusT =
  | 'called_due'
  | 'current'
  | 'discharged'
  | 'funding_failed'
  | 'past_due'
  | 'pending_recission'
  | 'pending_transfer'
  | 'rescinded'
;

export type AggregatedScheduledPaymentT = {
  is_autopay: boolean;
  is_multiple: boolean;
  is_pending: boolean;
  scheduled_amount: number;
  target_date: string;
};

export type NextPaymentT = {
  aggregated_scheduled_payment: AggregatedScheduledPaymentT;
  amount_due: number;
  due_date: string;
  original_amount_due?: number;
};

export type LoanSummaryResponseT = {
  current_owner: OwnerT;
  is_enrolled_in_autopay: boolean;
  loan_status: LoanStatusT;
  past_due_balance: number;
  product_type: ProductTypeT;
  has_draw_fee_saver?: boolean;
  has_statement_balance_fee_saver?: boolean;
  next_payment?: NextPaymentT;
};
